export const keys = (t) => [
    {
        key: 'avgLinksPerEvent',
        label: t('ai_tracking.keyword_detail.citation.chart.avgLinksPerEvent'),
        type: 'line',
        yAxisID: 'y1',
    },
    {
        key: 'runsLinks',
        label: t('ai_tracking.keyword_detail.citation.chart.answersWithLinks'),
        type: 'bar',
    },
    {
        key: 'runsNolinks',
        label: t('ai_tracking.keyword_detail.citation.chart.answersWithoutLinks'),
        type: 'bar',
    },
];
